import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mzt",
  "use": "icon-mzt-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-mzt\"><defs><style type=\"text/css\"></style></defs><path d=\"M163.84 81.92v860.16h696.32V81.92H163.84z m642.7648 806.4h-589.2096V135.68h589.2096v752.64zM753.02912 189.44H270.97088v645.12h482.05824V189.44z m-53.5552 591.36H324.52608v-537.6h374.94784v537.6z m-53.57568-215.04h-53.5552v-107.52h53.5552v107.52z\" p-id=\"23280\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol